import { Section, Site } from "./site";

export type SectionDefinition = {
  type: string;
  multiple: boolean;
  subType?: string;
  pro: boolean;
};

export const availableSections: SectionDefinition[] = [
  { type: "welcome", multiple: false, pro: false },
  { type: "about", multiple: true, pro: false },
  { type: "form", multiple: false, pro: true },
  { type: "catalog", multiple: true, pro: false },
  { type: "button", multiple: true, pro: true },
  { type: "floating-whatsapp", multiple: false, pro: true },
  { type: "links", multiple: true, pro: false },
  { type: "social", multiple: false, pro: false },
  { type: "location", multiple: true, pro: true },
  { type: "media", subType: "image", multiple: true, pro: true },
  { type: "media", subType: "video", multiple: true, pro: true },
  { type: "media", subType: "audio", multiple: true, pro: true },
  { type: "faq", multiple: true, pro: true },
  { type: "highlights", multiple: true, pro: true },
  { type: "testimonials", multiple: true, pro: true },
  { type: "pricing", multiple: true, pro: true },
];

export const isPlusSection = (type: string, subType?: string) =>
  !!availableSections.find(section => section.pro && section.type === type && section.subType === subType);

export const siteHasActivePlusSections = (site?: Site) =>
  !!site?.sections.some((section: Section) => section.active && isPlusSection(section.type, section.subType));
